import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { getAideIndustrieStub } from '../../../../config/aides-industrie';

export default function ExonerationCspePage() {
  const aide = getAideIndustrieStub('exoneration-cspe');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="industrie" />;
}
